// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';
import BasePaySection from './BasePaySection';
import DividedPaySection from './DividedPaySection';
import VariablePaySection from './VariablePaySection';
import FundsInfoSection from './FundsInfoSection';

const PayInfoSection = () => (
  <>
    <div fluid className="fields_group">
        <BasePaySection />
        <DividedPaySection />
        <VariablePaySection />
      </div>
      <FundsInfoSection hideElements={{ balance: true }} />

  </>
);

export default PayInfoSection;
